import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import AwardModal from "../Common_profile_details_modals/AwardModal/AwardModal";

function AwardsCard() {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");

  const [selectedAward, setSelectedAward] = useState({
    title: "",
    description: "",
  });

  const awards = [
    {
      title: "Best React.Js Frontend Developer",
      description:
        "Honored with the Best React.js Frontend Developer award for consistently delivering high-quality, responsive, and user-centric web applications. Recognized for expertise in React.js, JavaScript (ES6+), HTML5, CSS3, Bootstrap, responsive design, API integration, and performance optimization. Successfully developed scalable, reusable UI components while collaborating with cross-functional teams to create seamless user experiences.",
    },
    {
      title: "Employee of the Month",
      description:
        "Recognized for outstanding performance, teamwork, and delivering high-quality frontend applications while consistently meeting project deadlines.",
    },
  ];

  const handleClose = () => {
    setShowModal(false);
  };

  const handleAdd = () => {
    setModalMode("add");

    setSelectedAward({
      title: "",
      description: "",
    });

    setShowModal(true);
  };

  const handleEdit = (award) => {
    setModalMode("edit");
    setSelectedAward(award);
    setShowModal(true);
  };

  return (
    <>
      <Card className="profile-card-pattern profile-pattern-expandable">
        <Card.Body className="profile-card-pattern__body">
          {/* Header */}
          <div className="profile-card-pattern__header">
            <h2 className="profile-card-pattern__title">Awards</h2>

            <Button
              variant="link"
              className="profile-card-pattern__btn-add"
              onClick={handleAdd}
            >
              <span className="summary-card__edit-icon">➕</span>
            </Button>
          </div>

          {/* Award List */}
          {awards.map((award, index) => (
            <>
            <div className="profile-pattern-block__item" key={index}>
              <div className="profile-pattern-block__item-header">
                <h3 className="profile-pattern-block__main-text">
                  {award.title}
                </h3>

                <Button
                  variant="link"
                  className="profile-card-pattern__btn-edit"
                  onClick={() => handleEdit(award)}
                >
                  <span className="summary-card__edit-icon">✏️</span>
                </Button>
              </div>

              <p className="profile-pattern-block__sub-text">
                {award.description}
              </p>
            </div>

            <hr/>
            </>

          ))}
        </Card.Body>
      </Card>

      <AwardModal
        show={showModal}
        handleClose={handleClose}
        mode={modalMode}
        award={selectedAward}
      />
    </>
  );
}

export default AwardsCard;